<template>
  <div>
    <table class='table_flower' v-viewer>
      <tr>
        <th>
          流水号
        </th>
        <td>
          {{form.applicationNo}}
        </td>
        <th>
          申请业务
        </th>
        <td>
          {{form.applicationTypeText}}
          密码重置
        </td>
      </tr>
      <tr>
        <th>
          单位名称
        </th>
        <td>
          {{form.enterpriseName}}
        </td>
        <th>
          社会统一信用代码
        </th>
        <td>
          {{form.enterpriseCode}}
        </td>
      </tr>
      <tr>
        <th>
          人事姓名
        </th>
        <td>
          {{form.personnelName}}
        </td>
        <th>
          人事身份证号
        </th>
        <td>
          {{form.personnelIDCardNo}}
        </td>
      </tr>
      <tr>
        <th>
          人事联系方式
        </th>
        <td colspan="3">
          {{form.personnelPhone}}
        </td>
      </tr>
      <tr>
        <th>
          重置密码类型
        </th>
        <td colspan="3">
          {{form.resetPasswordTypeText}}
        </td>
      </tr>
      <!-- 个人 -->
      <template v-if="form.resetPasswordType==1">
        <tr>
          <th>
            申请人身份证人像面
          </th>
          <td>
            <img :src="this.$baseURL + '/file/preview/'+form.applicantIDCardFrontGuid" fit="fill" width="100px" height="100px" />
          </td>
          <th>
            申请人身份证国徽面
          </th>
          <td>
            <img :src="this.$baseURL + '/file/preview/'+form.applicantIDCardBackGuid" fit="fill" width="100px" height="100px" />
          </td>
        </tr>
        <tr>
          <th>
            申请人姓名
          </th>
          <td>
            {{form.applicantName}}
          </td>
          <th>
            申请人身份证号
          </th>
          <td>
            {{form.applicantIDCardNo}}
          </td>
        </tr>
        <tr>
          <th>
            申请人联系方式
          </th>
          <td colspan="3">
            {{form.applicantPhone}}
          </td>
        </tr>
      </template>
      <tr>
        <th>
          其他材料
        </th>
        <td colspan="3">
          <div class="_link" v-for="item in form.otherFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.otherFileGuidListPreview.length<1">无</span>
        </td>
      </tr>
      <tr>
        <th>
          签字文件
        </th>
        <td colspan="3">
          <div class="_link" v-for="item in form.resetPasswordPdfGuidPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.resetPasswordPdfGuidPreview.length<1">无</span>
        </td>
      </tr>

      <tr>
        <th>
          提交时间
        </th>
        <td>
          {{ form.submitTime}}
        </td>
        <th>
          状态
        </th>
        <td>
          {{ form.statusText}}
        </td>
      </tr>
      <tr v-if="form.status===$store.state.resetPasswordShowType">
        <th>新密码</th>
        <td colspan="3">{{showPassword?form.resetPassword:'********'}}
          <Icon @click="showPassword=!showPassword" :type="showPassword?'md-eye-off':'md-eye'" color="#2d8cf0" size="18" />
        </td>
      </tr>
    </table>

  </div>
</template>
<script>
export default {
  props: { form: Object },
  data() {
    return { showPassword: false }
  },
  methods: {
    handlePreview(url) {
      this.$emit('handlePreview', url)
    },
  },
}
</script>